import React, { useState } from 'react';
import moment from 'moment';
import renderHTML from 'react-render-html';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { Button } from 'telstra-ui/components/button/Button';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import Modal from 'telstra-ui/components/modal/Modal';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import { prepareDropDownOptionsArry } from '../../ams-homepage.actions';
import DeviceFilters from '../device-filters/device-filters';
import './trade-in-offer.css';

const TradeInOffer = (props) => {
  const {
    authorableContent,
    authorableContent: {
      tableInfoText,
      serviceNumber: serviceNumberText,
      username,
      device,
      tradeInValue,
      tradeInDevice,
      // includeIphone,
      convertToEpic,
      tradeIphoneDropDownText,
      itemSelectedText,
      filterTopLink,
      filterClearAll,
      filterEditTopLink,
      bulkActionLink,
      bulkActionText,
      bulkUpgradeTextPrefix,
      bulkUpgradeTextSuffix,
      bulkTotalCost,
      bulkTradeInCheckbox,
      bulkCancelText,
      bulkUpgradeText,
      tradeInNotEligible,
      mroEndDate,
      mroTotalMMC,
      mroETC,
      associateDevices,
      paginationNumbers,
      paginationBaseNumber,
      devicesPriceTooltipHeader,
      devicesPriceTooltip,
      imeiNumber,
      mobileETC,
      mobileEtcInfoText,
      formFields: {
        tradeIphoneDropDown,
        searchFields,
        contractTermPeriod,
        tradePlanDropDown,
        mobileHardwareETCPlans,
      },
    },
    serviceNumberArray,
    serviceNumbersWithFlag,
    onChangeCheckBox,
    tradeInDeviceCheckbox,
    migrateToEpicPlan,
    tradeDropDownValue,
    onChangeDropDown,
    contractTerm,
    serviceCheckboxVal,
    isBulkModalOpen,
    bulkModalOpen,
    bulkModalClose,
    bulkActionsApply,
    bulkNewDeviceValue,
    onBulkTradeInCheckBox,
    bulkTradeInChecked,
    onBulkChangeDropDown,
    serviceCheckAll,
    currentPage,
    pageChangeHandler,
    tradeInOfferSorting,
    tradeClickSorting,
    searchFieldSelectedOption,
    onSearchFieldChange,
    searchTextChange,
    searchText,
    onChangeContractValue,
    bulkTradePlanDropDownSelection,
    onBulkTradePlanChangeDropDown,
    currentDevicesList,
    updatedSummaryTable,
    onUpdatedSummaryTableValue,
    onServiceAllChangeCheckBox,
    mobileEtcDropDownValue,
    onChangeETCDropdown,
    onChangeETCHeaderDropdown,
    headerMobileETCValue,
  } = props;

  const [pageSize, setPageSize] = useState(parseInt(paginationBaseNumber, 10));

  const pageSizeOptions = paginationNumbers.split(',');

  const [filterOpen, setFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterClearAllStatus, setFilterClearAllStatus] = useState(false);
  const [totalRecords, setTotalRecords] = useState(serviceNumberArray.length);
  const [planSearchText, setPlanSearchText] = useState('');
  const [filterSearchedResults, setFilterSearchedResults] = useState([]);
  const [devicePriceModalIsOpen, setDevicePriceModalIsOpen] = useState(false);
  const numberOfPages = filterApplied ? Math.ceil(totalRecords / pageSize) : Math.ceil(serviceNumberArray.length / pageSize);
  const mobileEtcDropDownOptionsVal = mobileHardwareETCPlans.options;
  const mobileEtcDropDownOptions = prepareDropDownOptionsArry(mobileEtcDropDownOptionsVal);

  React.useEffect(() => {
    if (updatedSummaryTable) {
      setFilterApplied(false);
      setFilterOpen(false);
      setFilterClearAllStatus(true);
    }
  });

  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setTimeout(() => {
      const lastTableRow = document.getElementById('trade-in-table').lastElementChild.lastElementChild;
      lastTableRow.scrollIntoView();
    }, 200);
  };

  const onSearchText = () => {
    if (filterApplied) {
      return planSearchText;
    }
    return searchText;
  };

  const onSearchTextChange = (event) => {
    const filterSearchText = event.target.value;
    setPlanSearchText(filterSearchText);
    if (filterApplied) {
      let filterResults = [];
      if (searchFieldSelectedOption === 'number') {
        filterResults = filteredData.filter(numbers => numbers.serviceNumber.includes(filterSearchText));
      } else if (searchFieldSelectedOption === 'username') {
        filterResults = filteredData.filter(numbers => numbers.userName.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchFieldSelectedOption === 'device') {
        filterResults = filteredData.filter(numbers => numbers.deviceType.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchFieldSelectedOption === 'imeinumber') {
        filterResults = filteredData.filter(numbers => numbers.imeiNumber.includes(filterSearchText));
      } else if (searchFieldSelectedOption === 'nosearch') {
        filterResults = filteredData;
        setPlanSearchText('');
      }
      onPageChange(0);
      setTotalRecords(filterResults.length);
      setFilterSearchedResults(filterResults);
    } else {
      searchTextChange(event);
    }
  };

  const openDevicePriceDetails = () => {
    setDevicePriceModalIsOpen(true);
  };


  const onSearchDropDownChange = (event) => {
    if (filterApplied) {
      setPlanSearchText('');
      setFilterSearchedResults(filteredData);
      setTotalRecords(filteredData.length);
      onSearchFieldChange(event);
    } else {
      onSearchFieldChange(event);
    }
  };

  const getDataRows = () => {
    if (filterApplied && planSearchText.length > 0) {
      return filterSearchedResults;
    } else if (filterApplied) {
      return filteredData;
    }
    return serviceNumberArray;
  };

  const convertToEpicPlan = (number) => {
    migrateToEpicPlan(number);
  };

  const bulkApplyOnSelectedItems = () => {
    if (serviceCheckAll) {
      if (filterApplied && planSearchText.length > 0) {
        const selectedNumbers = filterSearchedResults.filter(serviceItem => serviceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      } else if (filterApplied) {
        const selectedNumbers = filteredData.filter(serviceItem => serviceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      } else {
        const selectedNumbers = serviceNumberArray.filter(serviceItem => serviceCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      }
    } else {
      const selectedNumbers = serviceNumberArray.filter(serviceItem => serviceCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      bulkActionsApply(selectedNumbers);
    }
  };

  const getNewDeviceValue = (deviceKey) => {
    const option = tradeIphoneDropDown.options.find(item => item.key === deviceKey);
    const defualtOption = tradeIphoneDropDown.options.find(item => item.key === 'NOSELECTION');
    if (option) {
      return option.value;
    }
    return defualtOption.value;
  };

  const getTradeInDisabledStatus = (deviceKey) => {
    const option = tradeIphoneDropDown.options.find(item => item.key === deviceKey);
    if (option && option.key !== 'NOSELECTION') {
      return false;
    }
    return true;
  };

  const getSearchSelectionValue = (searchKey) => {
    const option = searchFields.options.find(item => item.key === searchKey);
    const defualtOption = searchFields.options.find(item => item.key === 'nosearch');
    if (option) {
      return option.value;
    }
    return defualtOption.value;
  };

  const getNewContractValue = (key) => {
    const option = contractTermPeriod.options.find(item => parseInt(item.key, 10) === key);
    if (option) {
      return option.value;
    }
    return 'No Value To Select';
  };

  const getPlanValue = (planKey) => {
    const option = tradePlanDropDown.options.find(item => item.key === planKey);
    const defualtOption = tradePlanDropDown.options.find(item => item.key === 'NOPLANSELECTION');
    if (option) {
      return option.value;
    }
    return defualtOption.value;
  };

  const setUpdatedSummaryTable = () => {
    if (updatedSummaryTable) {
      onUpdatedSummaryTableValue();
    }
    setFilterOpen(!filterOpen);
  };

  const getNewMobileETCValue = (deviceKey) => {
    const option = mobileHardwareETCPlans.options.find(item => item.key === deviceKey);
    const defaultOption = mobileHardwareETCPlans.options.find(item => item.key === 'na');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const applyFilterOnFullData = (filterObj) => {
    let filterResults = serviceNumberArray;
    if (filterObj.fiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction === '1');
    }
    if (filterObj.nonFiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction !== '1');
    }
    if (filterObj.eligibleCheck) {
      filterResults = filterResults.filter(itm => parseInt(itm.tradeInValue, 10) > 0);
    }
    if (filterObj.notEligibleCheck) {
      filterResults = filterResults.filter(itm => parseInt(itm.tradeInValue, 10) === 0);
    }
    if (filterObj.mroCheck) {
      const currentDate = moment().format('DD/MM/YYYY');
      filterResults = filterResults.filter((itm) => {
        const mroDate = moment(itm.mroEndDate, 'DD/MM/YYYY');
        const mroEndDateData = itm.mroEndDate !== null ? itm.mroEndDate.toLowerCase() : '';
        return (
          mroEndDateData === '' ||
          mroEndDateData === 'na' ||
          mroEndDateData === 'n/a' ||
          moment(currentDate, 'DD/MM/YYYY').isAfter(mroDate, 'DD/MM/YYYY'));
      });
    }
    if (filterObj.currentDeviceValues.length > 0) {
      let currentDeviceResults = [];
      filterObj.currentDeviceValues.forEach((dev) => {
        const deviceResults = filterResults.filter(itm => itm.deviceType.toLowerCase() === dev.toLowerCase());
        currentDeviceResults = [...currentDeviceResults, ...deviceResults];
      });
      filterResults = [...currentDeviceResults];
    }
    if (filterObj.newDeviceValues.length > 0) {
      let newDeviceResults = [];
      filterObj.newDeviceValues.forEach((newDev) => {
        const newDeviceRes = filterResults.filter(itm => tradeDropDownValue[itm.serviceNumber] !== undefined
          && tradeDropDownValue[itm.serviceNumber].toLowerCase() === newDev.toLowerCase());
        newDeviceResults = [...newDeviceResults, ...newDeviceRes];
      });
      filterResults = [...newDeviceResults];
    }

    onPageChange(0);
    setPlanSearchText('');
    setFilterApplied(true);
    setFilterClearAllStatus(false);
    setFilteredData(filterResults);
    setTotalRecords(filterResults.length);
    setFilterOpen(false);
  };

  const cancelFilter = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
  };

  const clearFilterApplied = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(true);
  };

  const getTotalRecords = () => (filterApplied ? totalRecords : serviceNumberArray.length);

  const selectedItemsTradeOffer = () => {
    if (filterApplied && planSearchText.length > 0) {
      return Object.entries(serviceCheckboxVal)
        .filter(itm => serviceNumbersWithFlag[itm[0]].planName !== 'removePlan'
          && serviceNumbersWithFlag[itm[0]].dataOnly === false
          && filterSearchedResults.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    } else if (filterApplied) {
      return Object.entries(serviceCheckboxVal)
        .filter(itm => serviceNumbersWithFlag[itm[0]].planName !== 'removePlan'
          && serviceNumbersWithFlag[itm[0]].dataOnly === false
          && filteredData.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    }
    return Object.entries(serviceCheckboxVal)
      .filter(itm => serviceNumbersWithFlag[itm[0]].planName !== 'removePlan'
        && serviceNumbersWithFlag[itm[0]].dataOnly === false
        && serviceNumberArray.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
        && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
  };

  const tradeIphoneDropDownOptions = prepareDropDownOptionsArry(tradeIphoneDropDown.options);
  const searchFieldsDropDownOptions = prepareDropDownOptionsArry(searchFields.options);
  const contractTermDropDownOptions = prepareDropDownOptionsArry(contractTermPeriod.options);
  const tradePlanDropDownOptions = prepareDropDownOptionsArry(tradePlanDropDown.options);

  const onChangeAllCheckBox = (event) => {
    if (filterApplied) {
      onServiceAllChangeCheckBox(event, filteredData);
    } else {
      onServiceAllChangeCheckBox(event, serviceNumberArray);
    }
  };

  // Flex box row data
  const rowDataFlexSticky = dataTable => dataTable.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(numbers =>
    (
      <tr className="ri-table-row">
        <td className="sticky-col">
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-mobiles-mobile" className="mobile-pill-icon" />
          </div>
        </td>
        <td className="sticky-col1">
          <div className="table-item-text ri-flex-service-width inline">
            <Checkbox
              id={`${numbers.serviceNumber}-service`}
              onChange={onChangeCheckBox}
              checked={serviceCheckboxVal[numbers.serviceNumber]}
              label={formatPhoneNumber(numbers.serviceNumber)}
            />
            {numbers.fiveGInteraction === '1' &&
            <div className="p-2 table-item-text ri-flex-pill-width inline">
              <SvgIcon name="icon-bill-5g" className="mobile-pill-icon" />
            </div>
            }
            {numbers.fiveGInteraction !== '1' &&
            <div className="p-2 table-item-text ri-flex-pill-width-not-5g inline">
              <SvgIcon name="icon-system-circle-filled" className="mobile-pill-icon" />
            </div>
            }
          </div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-username table-item-text">{numbers.userName}</div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">{numbers.deviceType}</div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">${numbers.tradeInValue}</div>
        </td>
        {serviceNumbersWithFlag[numbers.serviceNumber].planName === 'mobileEpic' &&
        <td colSpan="2">
          <div className="p-2 ri-flex-iphone-width new-device-selection table-item-text">
            <Dropdown
              value={getNewDeviceValue(tradeDropDownValue[numbers.serviceNumber])}
              dropdownId={`${numbers.serviceNumber}-trade-dropdown`}
              options={tradeIphoneDropDownOptions}
              onOptionClick={e => onChangeDropDown(e)}
            />
          </div>
        </td>
        }
        {(serviceNumbersWithFlag[numbers.serviceNumber].planName === 'mobileEssential' ||
        serviceNumbersWithFlag[numbers.serviceNumber].planName === 'mobileEnhanced') &&
        <React.Fragment>
          <td>
            <div className="p-2 ri-flex-iphone-width-1 new-device-selection table-item-text">
              <Dropdown
                value={getNewDeviceValue(tradeDropDownValue[numbers.serviceNumber])}
                dropdownId={`${numbers.serviceNumber}-trade-dropdown`}
                options={tradeIphoneDropDownOptions}
                onOptionClick={e => onChangeDropDown(e)}
              />
            </div>
          </td>
          <td>
            <div className="p-2 ri-flex-iphone-width-2 new-device-selection table-item-text">
              <Button
                variant="secondary"
                onClick={() => convertToEpicPlan(numbers.serviceNumber)}
              >
                {`${serviceNumbersWithFlag[numbers.serviceNumber].planName.replace('mobile', '')}`}-{convertToEpic}
              </Button>
            </div>
          </td>
        </React.Fragment>
        }
        <td>
          <div className="ri-flex-normal-width table-item1">
            {parseInt(numbers.tradeInValue, 10) > 0 &&
            <Checkbox
              id={`${numbers.serviceNumber}-device`}
              onChange={onChangeCheckBox}
              checked={tradeInDeviceCheckbox[numbers.serviceNumber]}
              disabled={getTradeInDisabledStatus(tradeDropDownValue[numbers.serviceNumber])}
            />
            }
            {parseInt(numbers.tradeInValue, 10) === 0 &&
            tradeInNotEligible
            }
          </div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">{numbers.mroEndDate}</div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">${numbers.mroTotalMMC}</div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">${numbers.mroEtc}</div>
        </td>
        <td>
          <div className="new-device-selection table-item-text">
            <Dropdown
              value={getNewMobileETCValue(mobileEtcDropDownValue[numbers.serviceNumber])}
              dropdownId={`${numbers.serviceNumber}-mobileEtc-dropdown`}
              options={mobileEtcDropDownOptions}
              onOptionClick={e => onChangeETCDropdown(e)}
            />
          </div>
        </td>
        <td>
          <div className="p-2 ri-flex-normal-width table-item-text">{numbers.imeiNumber}</div>
        </td>
      </tr>
    ));

  return (
    <div id="trade-in-offer-section" className="trade-in-offer-section">
      <div className="trade-offer-table">
        <div className="row">
          <div className="col-12 table-info-text">
            {tableInfoText}
          </div>
          <div className="row associate-banner">
            <div className="col-12">
              <GenericAlert
                name="associate-device-banner-primary"
                description={associateDevices}
              />
            </div>
          </div>
          <div className="trade-in-header">
            <div className="col-12 header-section">
              <h5 className="sub-header">{mobileETC}</h5>
              <p className="sub-header-text">{renderHTML(mobileEtcInfoText)}</p>
            </div>
          </div>
          <div className="col-12 p-0">
            <div className="row">
              <div className="col-6 contract-info-section">
                <div className="col-12 label-info">{contractTermPeriod.label}</div>
                <div className="col-4 dropdown-box">
                  <Dropdown
                    value={getNewContractValue(contractTerm)}
                    dropdownId="contract-term-value"
                    options={contractTermDropDownOptions}
                    onOptionClick={onChangeContractValue}
                  />
                </div>
              </div>
              <div className="col-6 etc-treatment-section">
                <div className="col-12 label-info">{mobileETC}</div>
                <div className="col-4 dropdown-box">
                  <Dropdown
                    value={getNewMobileETCValue(headerMobileETCValue)}
                    dropdownId="mobile-etc-value"
                    options={mobileEtcDropDownOptions}
                    onOptionClick={e => onChangeETCHeaderDropdown(e, serviceNumberArray)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-2 table-action items">
            {selectedItemsTradeOffer()} {itemSelectedText}
          </div>
          <div className="col-2 table-action">
            <Button
              variant="primary"
              onClick={bulkModalOpen}
              size="medium"
              disabled={selectedItemsTradeOffer() === 0}
            >
              {bulkActionLink}
            </Button>
          </div>
          <div className="col-3 search-field-option">
            {(filterOpen === false) &&
              <Dropdown
                value={getSearchSelectionValue(searchFieldSelectedOption)}
                dropdownId="search-field-option"
                options={searchFieldsDropDownOptions}
                onOptionClick={onSearchDropDownChange}
                className="search-field-option-container"
              />
            }
          </div>
          <div className="col-2 search-field-option-text">
            {(filterOpen === false) &&
              <TextInput
                name="trade-search-text"
                onChange={onSearchTextChange}
                placeholder={searchFields.placeholder}
                value={onSearchText()}
              />
            }
          </div>
          <div className="col-1 table-action">
            {filterApplied &&
              <Button
                variant="primary"
                onClick={() => clearFilterApplied()}
                size="medium"
              >
                {filterClearAll}
              </Button>
            }
          </div>
          <div className="col-1 offset-1 table-action filter-button">
            <SvgIcon name="icon-product-filter" className="icon-filter" />
            <Button
              variant="secondary"
              onClick={() => setUpdatedSummaryTable()}
              size="medium"
              state="app"
            >
              {filterApplied ? filterEditTopLink : filterTopLink}
            </Button>
          </div>
          <div className="device-filter-section-main col-12">
            <DeviceFilters
              authorableContent={authorableContent}
              applyFilter={applyFilterOnFullData}
              cancelFilter={cancelFilter}
              filterOpen={filterOpen}
              filterApplied={filterApplied}
              currentDevicesList={currentDevicesList}
              filterClearAll={filterClearAllStatus}
            />
          </div>
          <div className="sticky-wrapper col-12">
            <div className="sticky-scroller">
              <table className="sticky-table" id="trade-in-table">
                <thead>
                  <tr>
                    <th className="sticky-col">&nbsp;</th>
                    <th className="sticky-col1">
                      <div className="table-title ri-flex-service-width-header">
                        <Checkbox
                          id="all-service"
                          onChange={e => onChangeAllCheckBox(e)}
                          checked={getTotalRecords() > 0 && getTotalRecords() === selectedItemsTradeOffer()}
                          label={serviceNumberText}
                        />
                        {tradeInOfferSorting.numberSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="number-sort-asc"
                            onClick={() => tradeClickSorting('number', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {tradeInOfferSorting.numberSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="number-sort-desc"
                            onClick={() => tradeClickSorting('number', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {username}
                        {tradeInOfferSorting.userSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="user-sort-asc"
                            onClick={() => tradeClickSorting('userName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {tradeInOfferSorting.userSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="user-sort-desc"
                            onClick={() => tradeClickSorting('userName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className=" p-2 table-title ri-flex-normal-width">
                        {device}
                        {tradeInOfferSorting.deviceSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="device-sort-asc"
                            onClick={() => tradeClickSorting('deviceType', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {tradeInOfferSorting.deviceSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="device-sort-desc"
                            onClick={() => tradeClickSorting('deviceType', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {tradeInValue}
                        {tradeInOfferSorting.valueSortType === 'ASC' && filterApplied === false &&
                          <div
                            className="value-sort-asc"
                            onClick={() => tradeClickSorting('tradeInValue', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {tradeInOfferSorting.valueSortType === 'DESC' && filterApplied === false &&
                          <div
                            className="value-sort-desc"
                            onClick={() => tradeClickSorting('tradeInValue', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th colSpan="2">
                      <div className="p-2 table-title ri-flex-iphone-width">
                        {tradeIphoneDropDownText}
                        <button onClick={openDevicePriceDetails} className="device-price-open-icon-btn">
                          <SvgIcon name="icon-system-info" className="device-price-open-icon" />
                        </button>
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {tradeInDevice}
                      </div>

                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {mroEndDate}
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {mroTotalMMC}
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {mroETC}
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-normal-width">
                        {mobileETC}
                      </div>
                    </th>
                    <th>
                      <div className="p-2 table-title ri-flex-normal-width">
                        {imeiNumber}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowDataFlexSticky(getDataRows())}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={getTotalRecords()}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <Modal
        isOpen={devicePriceModalIsOpen}
        onShowModal={() => setDevicePriceModalIsOpen(false)}
        size="large"
        className="device-modal"
      >
        <Modal.Header>
          {devicesPriceTooltipHeader}
        </Modal.Header>
        <Modal.Body>
          {renderHTML(devicesPriceTooltip)}
        </Modal.Body>
      </Modal>


      <Modal
        isOpen={isBulkModalOpen}
        onShowModal={bulkModalClose}
        size="large"
        className="bulk-tradein-modal"
      >
        <Modal.Header>{bulkActionText}</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              {bulkUpgradeTextPrefix} {selectedItemsTradeOffer()} {bulkUpgradeTextSuffix}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Dropdown
                value={getPlanValue(bulkTradePlanDropDownSelection)}
                dropdownId="bulk-trade-plan-dropdown"
                options={tradePlanDropDownOptions}
                onOptionClick={onBulkTradePlanChangeDropDown}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 custom-bulk-dropdown">
              <Dropdown
                value={getNewDeviceValue(bulkNewDeviceValue)}
                dropdownId="bulk-trade-dropdown"
                options={tradeIphoneDropDownOptions}
                onOptionClick={onBulkChangeDropDown}
                optionClassName="tl-dropdown-above"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Checkbox
                id="bulk-trade-in-devices"
                onChange={onBulkTradeInCheckBox}
                checked={bulkTradeInChecked}
                label={bulkTradeInCheckbox}
                disabled={bulkNewDeviceValue === 'NOSELECTION'}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {bulkTotalCost}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="xSmall"
            onClick={bulkModalClose}
          >{bulkCancelText}</Button>
          <Button
            variant="super"
            size="medium"
            state="app"
            onClick={() => bulkApplyOnSelectedItems()}
            disabled={getTradeInDisabledStatus(bulkNewDeviceValue) && bulkTradePlanDropDownSelection === 'NOPLANSELECTION'}
          >{bulkUpgradeText}</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default TradeInOffer;
